import React from "react";
import { cn } from "@/lib/utils";

interface SectionContainerProps {
  children: React.ReactNode;
  background?: "dark" | "light" | "transparent" | "gradient";
  maxWidth?: "full" | "6xl" | "7xl";
  className?: string;
  // Marks this section for `useLightSectionBehindHeader`, so the fixed
  // header can switch its text color while this section scrolls behind it.
  // Only meaningful for a solid light background — leave unset for
  // gradients or video, which aren't reliably one color at the top edge.
  headerInvert?: boolean;
}

const SectionContainer: React.FC<SectionContainerProps> = ({
  children,
  background = "transparent",
  maxWidth = "7xl",
  className,
  headerInvert,
}) => {
  const backgroundClasses = {
    dark: "bg-background",
    light: "bg-pure-white",
    transparent: "",
    gradient: "bg-gradient-to-b from-background via-muted to-foreground/10",
  };

  const maxWidthClasses = {
    full: "max-w-full",
    "6xl": "max-w-6xl",
    "7xl": "max-w-7xl",
  };

  return (
    <div
      data-header-invert={headerInvert ? "true" : undefined}
      className={cn(
        "flex w-full flex-col items-center justify-center",
        "px-5 py-24",
        "py-16 lg:px-28",
        backgroundClasses[background],
        className
      )}
    >
      <div className={cn("w-full", maxWidthClasses[maxWidth])}>{children}</div>
    </div>
  );
};

export default SectionContainer;
